import React from "react";
import styles from "./NegotiationBot.module.css";
import {
  getDecisionText,
  normalizeMoneyText,
} from "./negotiationUtils";

const NegotiationHistory = ({ sessionDetail }) => {
  const rounds = Array.isArray(sessionDetail?.rounds) ? sessionDetail.rounds : [];
  const currency = sessionDetail?.currency || "INR";

  return (
    <section className={styles.panel}>
      <div className={styles.compactHeader}>
        <div>
          <span className={styles.eyebrow}>Lifecycle</span>
          <h4>{sessionDetail?.vendor_name || "Negotiation timeline"}</h4>
        </div>
        <span className={styles.statusPill}>
          {getDecisionText(sessionDetail?.decision || sessionDetail?.status)}
        </span>
      </div>

      <div className={styles.timeline}>
        <div className={styles.timelineNode}>
          <span></span>
          <div>
            <strong>Initial Quote</strong>
            <p>{normalizeMoneyText(sessionDetail?.initial_price, currency)}</p>
          </div>
        </div>

        {rounds.map((round) => (
          <div className={styles.timelineNode} key={round.negotiation_round_token || round.round}>
            <span></span>
            <div>
              <strong>Round {round.round}</strong>
              <p>{normalizeMoneyText(round.offered_price, round.currency)}</p>
              <small>{getDecisionText(round.decision)}</small>
            </div>
          </div>
        ))}

        <div className={styles.timelineNode}>
          <span></span>
          <div>
            <strong>{getDecisionText(sessionDetail?.decision || sessionDetail?.status)}</strong>
            <p>{rounds.length ? "Latest vendor offer recorded" : "Waiting for vendor reply"}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NegotiationHistory;
